import { render, staticRenderFns } from "./PromotionModalContent.vue?vue&type=template&id=06ba9818"
import script from "./PromotionModalContent.vue?vue&type=script&lang=js"
export * from "./PromotionModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports